export default __webpack_public_path__ + "static/media/light-active-notification.f261d115.svg";